import { render, staticRenderFns } from "./dataScreening.vue?vue&type=template&id=a37ad2b2&scoped=true&"
import script from "./dataScreening.vue?vue&type=script&lang=js&"
export * from "./dataScreening.vue?vue&type=script&lang=js&"
import style0 from "./dataScreening.vue?vue&type=style&index=0&id=a37ad2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37ad2b2",
  null
  
)

export default component.exports